import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import CommitmentSection from "../CommitmentSection";
import OfflineMarketingBanner from './OfflineMarketingBanner';
import OfflineMarketingInfo from './OfflineMarketingInfo';

const OfflineMarketingDetails = () => {
  return (
    <>
      <NavbarComponent />
      <OfflineMarketingBanner />
      <CommitmentSection />
      <OfflineMarketingInfo />
      <Footer />
    </>
  );
};

export default OfflineMarketingDetails;
